import { Component } from 'react';
export class ExtensionWrap extends Component {
	render() {
		let extensionComponentName = this.props.cmp_type;
		const { cmp_data } = this.props;
		if(cmp_data && cmp_data.advance && cmp_data.advance.cmp_render) {
			const { status = 'enable', viewPath } = cmp_data.advance.cmp_render;
			if(viewPath  && status === 'enable') {
				extensionComponentName = viewPath;
			}
		}

		if(cmp_data && cmp_data.viewPath) {
			extensionComponentName = this.props.cmp_data.viewPath;
		}

		if(!window._beisenCmp || !window._beisenCmp[extensionComponentName]) {
			return this.props.children;
		}

		let ExtensionComponent = window._beisenCmp[extensionComponentName];
		//todo 加入内置类型的判断，如果window._beisenCmp中获取到的是内置类型应该如何渲染，对应全局替换为系统内置字段的场景
		let { children, ...other } = this.props;
		return <ExtensionComponent {...other} />;
	}
}


export function getExtensionCmp(cmpMetaData) {
	if(!cmpMetaData) {
		return null;
	}

	let extensionComponentName = cmpMetaData.cmp_type;
	const { cmp_data } = cmpMetaData;
	if(cmp_data && cmp_data.advance && cmp_data.advance.cmp_render) {
		const { status = 'enable', viewPath } = cmp_data.advance.cmp_render;
		if (viewPath && status === 'enable') {
      extensionComponentName = viewPath;
    }
	}

	if(cmp_data && cmp_data.viewPath) {
		extensionComponentName = cmp_data.viewPath;
	}


	if(window._beisenCmp && window._beisenCmp[extensionComponentName]) {
		return window._beisenCmp[extensionComponentName];
	}
	return null;
}


export function getExtensionCmpByViewPath(viewPath) {
	if(!window._beisenCmp || !window._beisenCmp[viewPath]) {
		return null;
	}
	return window._beisenCmp[viewPath];
}



// WEBPACK FOOTER //
// ./src/components/util/extension.js